import { useEffect } from "react";
import { motion } from "framer-motion";
import { Star, Loader2 } from "lucide-react";
import { useThirdPartyActive } from "@/lib/third-party";

const REVIEW_WIDGET_SCRIPT = "https://reputationhub.site/reputation/assets/review-widget.js";

const ReviewWidget = () => {
  const active = useThirdPartyActive();

  useEffect(() => {
    if (!active) return;
    if (document.querySelector(`script[src="${REVIEW_WIDGET_SCRIPT}"]`)) return;
    const script = document.createElement("script");
    script.src = REVIEW_WIDGET_SCRIPT;
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  }, [active]);

  return (
    <section className="section-padding bg-muted/30">
      <div className="container-max">
        <div className="text-center mb-10">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Reviews
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl text-foreground mb-4 tracking-tight font-bold"
          >
            What Our <span className="text-gradient-primary">Clients</span> Say
          </motion.h2>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-secondary text-secondary" />
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          {active ? (
            <iframe
              className="lc_reviews_widget"
              src="https://reputationhub.site/reputation/widgets/review_widget/AhqRkRHoFZiSJXH1oAJL?widgetId=6a6117ca9155d48e552ddcd3"
              frameBorder="0"
              scrolling="no"
              style={{ minWidth: "100%", width: "100%", minHeight: "420px", border: "none" }}
              title="Customer Reviews"
            />
          ) : (
            <div
              style={{ minHeight: "420px" }}
              className="flex flex-col items-center justify-center gap-3 rounded-2xl bg-card/40 border border-border/40 text-muted-foreground"
              aria-hidden="true"
            >
              <Loader2 className="h-6 w-6 text-primary motion-safe:animate-spin" />
              <span className="text-sm">Loading customer reviews…</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReviewWidget;
